export enum FormEditStyle {
    Inline = 1,
    Form = 2,
    ReadOnly = 3
}
